import CheckedStatus from './checkedStatus';

export default CheckedStatus;
